"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { showDebugLog } from '@/utils/log'

// import * as utils from '@/utils/auth'

// import moment from 'moment'

const tempTeam = [];
var _default = exports.default = {
  name: "TrainingTeam",
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  props: {
    parentTeams: {
      type: Array,
      default: tempTeam
    },
    internalTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      myTrainingTeams: [],
      fullscreenloading: false,
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: "smallDrop"
    };
  },
  created() {
    /* no code */
    this.myTrainingTeams = this.parentTeams[0].members;
    //console.info("b:"+JSON.stringify(this.myTrainingTeams));
  },
  methods: {
    tableRowClassName({
      rowIndex
    }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "oddRow";
      }
      return "evenRow";
    },
    handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess({
      results,
      header
    }) {
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          trainingId: _lodash.default.trim(r.trainingId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.familyName),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload() {
      if (this.tableData.length <= 0) {
        const msg = this.$i18n.t("otrTraining.msgEmptyRecord");
        (0, _log.displayPopupMessage)(msg, "error");
        return false;
      }
      const trainingId = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.createAccount();
      (0, _ga.writeGaEvent)(this, "Training", `${_lifehikesInitData.userEvent.training.uploadParticipant}`, oEmail, `Training Id: ${trainingId}`);
    },
    async createAccount() {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.isShowResult = true;
      for (let i = 0; i < this.tableData.length; i++) {
        await (0, _training.autoAddParticipant)(token, this.tableData[i]).then(response => {
          (0, _log.showDebugLog)("registerEnroll-API-OK", response.data);
          this.tableData[i].result = "Success";
          this.$set(this.tableData, i, this.tableData[i]);
          (0, _log.showDebugLog)("Table content row", i);
          this.noOfSuccess += 1;
        }).catch(error => {
          // showDebugLog('registerEnroll-API-Fail', error.response)
          const msg = typeof error.response === "undefined" ? error.toString() : error.response.data.message;
          this.noOfFail += 1;
          this.tableData[i].result = "Fail:" + msg;
          this.$set(this.tableData, i, this.tableData[i]);
          // showDebugLog('registerEnroll-API-Fail', msg)
          (0, _log.showDebugLog)("Table content row", i);
        });
      }
      await this.getTeam();
      this.fullscreenloading = false;
    },
    getTeam() {
      const id = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      (0, _training.getTrainingTeams)(token, id).then(response => {
        (0, _log.showDebugLog)("ShowTeam", response.data.rows);
        //this.myTrainingTeams = response.data.rows;
        let rows = response.data.rows;
        if (rows != null && rows.length > 0) {
          this.myTrainingTeams = rows[0].members;
        }
      }).catch(error => {
        (0, _log.showDebugLog)("GetTeam-API-error", error);
      });
    },
    EmailFormatErrorStyle(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== "" ? "error" : "";
    },
    unenroll(userUuid, name) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const trainingId = typeof this.$route.params.id === "undefined" ? "" : this.$route.params.id;
      this.$confirm(`Are you sure you want to un-enroll this user: ${name}?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(() => {
        this.$confirm(`WARNING, this action cannot be undone. ${name} will lose all access to this event/program.`, "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }).then(() => {
          (0, _training.unenrolParticipant)(token, trainingId, userUuid).then(response => {
            var data = response.data;
            if (data.message == "success") {
              this.getTeam();
              this.$message({
                type: "success",
                message: "Un-enroll process completed"
              });
            } else {
              this.$message({
                type: "error",
                message: `Un-enroll Process Fail, Reason: ${data.message}`
              });
            }
          }).catch(error => {
            this.$message({
              type: "error",
              message: "Un-enroll Process Fail!"
            });
            (0, _log.showDebugLog)("training-unenroll-error", error);
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "Action canceled"
          });
        });
        /*
         */
      }).catch(() => {
        this.$message({
          type: "info",
          message: "Action canceled"
        });
      });
    },
    sort_change(column) {
      let newItems = this.myTrainingTeams.sort(this.sortFun(column.prop));
      //console.info(newItems)
      if (column.order === "descending") {
        newItems = newItems.reverse();
      }
      this.myTrainingTeams = newItems;
    },
    sortFun(attr) {
      return function (item1, item2) {
        item1 = item1[attr].toLowerCase();
        item2 = item2[attr].toLowerCase();
        if (item1 < item2) {
          return -1;
        } else if (item1 > item2) {
          return 1;
        } else {
          return 0;
        }
      };
    }
  }
};